import React, { useState, useEffect } from 'react';
import Loader from '../common/Loader';
import cardUtils from '../../utils/cardUtils';
import shoppingCart from '../../utils/shoppingCart';
import EmptyCartButton from './EmptyCartButton';
import ShoppingCartList from './ShooppingCartList';
import TotalAmount from '../common/TotalAmount';
import Button from '../common/Button';

const ShoppingCart = () => {
  const [loading, setLoading] = useState(false);
  const [sortedCards, setSortedCards] = useState([]);
  const [showCards, setShowCards] = useState(true);

  useEffect(() => {
    setLoading(true);
    setSortedCards(cardUtils.groupCardsByStore(shoppingCart.getShoppingCart()));
    setLoading(false);
  }, []);

  const onRemoveCardFromCart = () => {
    setLoading(true);
    setSortedCards(cardUtils.groupCardsByStore(shoppingCart.getShoppingCart()));
    setLoading(false);
  };

  return (
    <div className="flex flex-col gap-y-4">
      <h1 className="text-2xl text-center">
        <i className="fas fa-shopping-cart mr-2"></i>
        Carrito de compras
      </h1>
      <h4>
        Las cartas que fuiste agregando, agrupadas por tienda y con el total de
        cada una. Podés abrir de una vez todas las publicaciones de una tienda o
        enviarle el pedido por mail.
      </h4>
      <div className="flex flex-col h-full">
        <div className="flex flex-row justify-between mb-4 gap-x-4">
          <div className="lg:w-1/4 sm:w-full mb-2">
            <EmptyCartButton onEmptyCart={() => setSortedCards([])} />
          </div>
          <div className="flex flex-row gap-x-4 lg:w-1/4 sm:w-full mb-2">
            <div className="w-full sm:w-1/2">
              <Button
                className="w-full "
                iconClass="fas fa-id-card"
                onClick={() => setShowCards(true)}
              />
            </div>
            <div className="w-full sm:w-1/2">
              <Button
                className="w-full "
                iconClass="fas fa-list-alt"
                onClick={() => setShowCards(false)}
              />
            </div>
          </div>
        </div>

        {loading && <Loader />}
        {!loading && (
          <div className="flex flex-col gap-y-4">
            <TotalAmount cards={shoppingCart.getShoppingCart()} />
            {sortedCards.map(cardsByStore => {
              return (
                <ShoppingCartList
                  key={cardsByStore.store}
                  store={cardsByStore.store}
                  cards={cardsByStore.cards}
                  showCards={showCards}
                  onRemoveCardFromCart={onRemoveCardFromCart}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ShoppingCart;
